import { TranslocoPipe } from '@jsverse/transloco';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ButtonModule } from '@openng/optimus-ui/button';
import { AppLogoComponent } from '../../../design/components/app-logo/app-logo.component';

@Component({
  selector: 'app-landing-nav',
  standalone: true,
  imports: [TranslocoPipe, RouterLink, ButtonModule, AppLogoComponent],
  template: `
    <nav class="landing-nav" [attr.aria-label]="'landing.landingNavigation' | transloco">
      <div class="nav-inner">
        <a class="brand" routerLink="/" [attr.aria-label]="'landing.roundnetCompanionHome' | transloco"><app-logo /><strong>{{ 'landing.roundnetCompanion' | transloco }}</strong></a>
        <div class="nav-actions">
          <a class="nav-link" routerLink="/pricing">{{ 'landing.pricing' | transloco }}</a>
          <a pButton routerLink="/login" [outlined]="true" class="nav-button nav-button--login"><span pButtonLabel>{{ 'landing.logIn' | transloco }}</span></a>
          <a pButton routerLink="/register" class="nav-button"><span pButtonLabel>{{ 'landing.getStarted' | transloco }}</span></a>
        </div>
      </div>
    </nav>
  `,
  styles: [`
    .landing-nav {
      backdrop-filter: blur(12px);
      background: color-mix(in srgb, var(--color-bg) 82%, transparent);
      border-bottom: 1px solid var(--color-border-subtle);
      left: 0;
      padding: var(--space-3) clamp(1rem, 4vw, 3rem);
      position: sticky;
      right: 0;
      top: 0;
      z-index: 20;
    }

    .nav-inner {
      align-items: center;
      display: flex;
      gap: var(--space-4);
      justify-content: space-between;
      margin-inline: auto;
      min-height: var(--control-height-xl);
      width: min(100%, 74rem);
    }

    .brand {
      align-items: center;
      display: inline-flex;
      gap: var(--space-3);
      min-width: 0;
      text-decoration: none;
    }

    .brand strong {
      color: var(--color-text-primary);
      font-size: 0.95rem;
      font-weight: 900;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .nav-actions {
      align-items: center;
      display: flex;
      gap: var(--space-4);
    }

    .nav-link {
      color: var(--color-text-secondary);
      font-size: 0.9rem;
      font-weight: 800;
      text-decoration: none;
    }

    .nav-link:hover,
    .nav-link:focus-visible {
      color: var(--color-text-primary);
    }

    .nav-button {
      justify-content: center;
      min-height: 2.55rem;
      padding-inline: var(--space-6);
      white-space: nowrap;
    }

    @media (max-width: 560px) {
      .brand strong { display: none; }
      .nav-link { display: none; }

      .nav-actions {
        flex: 1;
        justify-content: flex-end;
      }
    }
  `],
})
export class LandingNavComponent {}
